export type OpcaoRedirecionamento = {
  nome: string;
  codigo: string;
  imagem_url: string | null;
  selected: boolean;
};

export enum ModoRedirecionamento {
  DIRETO = 'DRT',
  PLANEJADO = 'PLJ',
}

export type RedirecionamentoConfig = {
  url: string;
  modo: ModoRedirecionamento;
  multipla_escolha: boolean;
  opcoes: OpcaoRedirecionamento[];
};
